import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { ShowMoreBtn } from '../../components/ShowMoreBtn';
import { IApplicationState } from '../../types/redux';
import { EGetFavoriteEntitiesStatus } from '../../types/results';

export const ShowMoreBtnContainer = () => {
  const hasMore = useSelector((state: IApplicationState) => state.results.hasMore);
  const favoriteEntitiesLength = useSelector((state: IApplicationState) => state.results.favoriteEntities.length);
  const status = useSelector((state: IApplicationState) => state.results.status);
  const dispatch = useDispatch();

  const loadMore = () => {
    dispatch(fetchFavoriteEntities({ offset: favoriteEntitiesLength, next: true }));
  };

  if (!hasMore || !favoriteEntitiesLength) {
    return null;
  }

  return <ShowMoreBtn onClick={loadMore} loading={status === EGetFavoriteEntitiesStatus.NextPageLoading} />;
};
